module.exports = __webpack_public_path__ + "media/images/logo-93db5f9aff242e8a8cb5b2998f46eb59.svg";